import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { authService } from '@/lib/auth-direct';

export function useRedirectIfAuthenticated(destination = '/dashboard') {
  const router = useRouter();

  useEffect(() => {
    if (authService.isAuthenticated()) {
      router.replace(destination);
    }
  }, [router, destination]);
}
